import { Routes } from '@capital-access/common/router';

export const routes: Routes = [{ path: '**', redirectTo: '' }];
